/// <reference types="webpack-env" />
import 'core-js/es6/array'
import 'core-js/es7/array'
import 'core-js/es7/string'
import * as Raven from 'raven-js'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as ReactModal from 'react-modal'
import LoadablePage from 'web-makeup/dist/LoadablePage'

import ErrorBoundary from './components/ErrorBoundary'
import * as serviceWorker from './registerServiceWorker'
import GlobalStyle from './style'

export const requestSanitizer = request => {
  try {
    // Hide email and password
    const body = JSON.parse(request.body)
    if (body.variables && body.variables.password) {
      body.variables.password = null
    }
    if (body.variables && body.variables.email) {
      body.variables.email = null
    }
    request.body = JSON.stringify(body)
  } catch (err) {
    // Ignore error
  }
  if (request.headers && request.headers.Authorization) {
    request.headers.Authorization = null
  }
  return request
}

export const render = (Component, el = document.getElementById('root') as HTMLElement) => {
  if (window.env && window.env.SENTRY_DSN) {
    Raven.config(window.env.SENTRY_DSN).install()
  }

  if (window.env && window.env.APPLICATION_TAG) {
    Raven.setRelease(window.env.APPLICATION_TAG)
  }

  ReactModal.setAppElement(el)

  ReactDOM.render(
    <ErrorBoundary>
      <GlobalStyle />
      <Component env={window.env} />
    </ErrorBoundary>,
    el
  )
}

if (process.env.NODE_ENV !== 'test') {
  const App = LoadablePage({
    loader: () => import('./components/App' /* webpackChunkName: "App" */),
  })
  render(App)
}

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default
    render(NextApp)
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.tsx